import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f79410",
      d: "M30.75 15.476v-.372h-.097l-.111.256-.111-.255h-.098v.37h.068v-.28l.105.242h.072l.105-.241v.28h.066Zm-.613 0v-.308h.124v-.062h-.316v.062h.124v.308z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ff5f00",
      d: "M19.767 17.067h-8.36V2.043h8.36z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#eb001b",
      d: "M11.938 9.555a9.54 9.54 0 0 1 3.65-7.512A9.5 9.5 0 0 0 9.682 0C4.406 0 .129 4.278.129 9.555s4.277 9.556 9.554 9.556a9.5 9.5 0 0 0 5.904-2.044 9.54 9.54 0 0 1-3.65-7.512Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#f79e1b",
      d: "M31.044 9.556c0 5.277-4.277 9.555-9.554 9.555a9.5 9.5 0 0 1-5.904-2.043 9.54 9.54 0 0 0 3.65-7.512 9.54 9.54 0 0 0-3.65-7.512A9.52 9.52 0 0 1 21.492 0c5.275 0 9.552 4.279 9.552 9.556"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "master-card"}) } }